'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stripeElementStyleConfig = exports.CardIcon = exports.ErrorMessage = exports.FormContainer = exports.AlignedContainer = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _Row = require('web-makeup/dist/Row');

var _Row2 = _interopRequireDefault(_Row);

var _style = require('../style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var AlignedContainer = exports.AlignedContainer = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"])));
var FormContainer = exports.FormContainer = (0, _styledComponents2.default)(_Row2.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 0.5rem;\n  label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n    color: ", ";\n  }\n\n  .ant-input:focus,\n  .ant-input:hover {\n    border-color: ", ";\n    box-shadow: none;\n  }\n\n  .StripeElement {\n    box-sizing: border-box;\n    height: 42px;\n    padding: 0.75rem;\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    line-height: 1.5;\n    color: rgba(0, 0, 0, 0.65);\n    background-color: white;\n    background-image: none;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    transition: all 0.3s;\n  }\n"], ["\n  margin-top: 0.5rem;\n  label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n    color: ", ";\n  }\n\n  .ant-input:focus,\n  .ant-input:hover {\n    border-color: ", ";\n    box-shadow: none;\n  }\n\n  .StripeElement {\n    box-sizing: border-box;\n    height: 42px;\n    padding: 0.75rem;\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    line-height: 1.5;\n    color: rgba(0, 0, 0, 0.65);\n    background-color: white;\n    background-image: none;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    transition: all 0.3s;\n  }\n"])), _style.COLOR_MIDNIGHT, _style.COLOR_MIDNIGHT);
var ErrorMessage = exports.ErrorMessage = _styledComponents2.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #eb1c26;\n"], ["\n  color: #eb1c26;\n"])));
var CardIcon = exports.CardIcon = (0, _styledComponents2.default)(_CloudinaryImage2.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: 16px;\n  top: 33px;\n  z-index: 2;\n"], ["\n  position: absolute;\n  right: 16px;\n  top: 33px;\n  z-index: 2;\n"])));
var stripeElementStyleConfig = exports.stripeElementStyleConfig = {
    fontSize: '14px',
    fontWeight: 200,
    '::placeholder': {
        color: '#BABABA'
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=CreditCardForm.style.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/CreditCardForm/CreditCardForm.style.js
// module id = 1974
// module chunks = 0